import type { QueryClient } from "@tanstack/react-query";
import { journalsQueries } from "@entities/journal";

export type TitleJournalMutateOptions = {
  onSuccess?: () => void;
  onError?: () => void;
  onSettled?: () => void;
  skipInvalidate?: boolean;
};

export function invalidateTitleJournalQueries(
  queryClient: QueryClient,
  titleId: string,
) {
  queryClient.invalidateQueries({
    queryKey: journalsQueries.getTitleJournal({ titleId }).queryKey,
  });
  queryClient.invalidateQueries({
    queryKey: journalsQueries.getJournalSignersList(titleId).queryKey,
  });
  queryClient.invalidateQueries({
    queryKey: journalsQueries.getResponsibleCommentList(titleId).queryKey,
  });
}

export function withTitleJournalInvalidation(
  queryClient: QueryClient,
  titleId: string,
  mutateOptions?: TitleJournalMutateOptions,
) {
  const { skipInvalidate, onSuccess, onError, onSettled } = mutateOptions ?? {};

  return {
    onSuccess: () => {
      if (!skipInvalidate) {
        invalidateTitleJournalQueries(queryClient, titleId);
      }
      onSuccess?.();
    },
    onError: () => {
      if (!skipInvalidate) {
        invalidateTitleJournalQueries(queryClient, titleId);
      }
      onError?.();
    },
    onSettled,
  };
}
